import setBreakpoint from './setBreakpoint.js';
import getBreakpoint from './getBreakpoint.js';

export defa mx-1  ult { setBreakpoint, getBreakpoint };
